<template>
<div class="vue">
  <div v-if="error!=null">
    You have experienced some errors, please check your permissions and make sure you are logged in.
    error code: {{error}}
  </div>
  <div v-if="error==null && taskOverview.taskId > 0">
    <div class="container large taskHeader">
      <div class="row">
        <div class="col s12 m12 l8 taskTitle">
          <p><a href="/">Home</a> / <a href="/home/projects.html?sensorId=ARU">ARU</a> / <a :href="'./?projectId=' + taskOverview.projectId">{{taskOverview.projectFullName}} </a> /</p>
          <h1>{{taskOverview.recordingName}}</h1>
          <p class="NoiseLevel" v-if="taskOverview.meanDecibels != null">
            <span>Task Decibels(dBFS):</span>
            <span>Mean</span> ({{taskOverview.meanDecibels}})
            <span>Max</span> ({{taskOverview.maxDecibels}})
            <span>RMS</span> ({{taskOverview.rmsDecibels}})
          </p>
        </div>
        <div class="col s12 m12 l4 ">
          <p v-if="taskOverview.isUserAdmin || isStatusOptionVisible">Status: <span class="currentStatus">{{currentStatus}}</span></p> <!-- display on top -->
          <div :class="{'no-statusOption':!isStatusOptionVisible}" class="row">
            <div class="col s6">
              <p v-if="!taskOverview.isUserAdmin && !isStatusOptionVisible">Status: <span class="currentStatus">{{currentStatus}}</span></p> <!-- display on same row with next taks button when no select -->
              <select v-if="taskOverview.isUserAdmin" :disabled="!taskOverview.canUserModify" id="statusSelector" @change="updateTaskStatus" v-model.number="orgStatusId" :value="orgStatusId" type="number">
                <option v-for="(option, index) in options.taskStatus" :key="'status'+index" :value="option.id">{{option.type}}</option>
              </select>
              <div v-if="!taskOverview.isUserAdmin && !isFullReadUser && isStatusOptionVisible">
                <select :disabled="!taskOverview.canUserModify || (taskOverview.isUserTranscriber && (task.statusId === 4 || task.statusId === 5 || task.statusId === 7))" id="statusSelector" @change="markAsCompelete" v-model.number="newStatusId" type="number">
                  <option value="-1">Update Status</option>
                  <option v-for="(option, index) in markableTaskStatus" :key="'status'+index" :value="option.id" >
                    {{option.type}}
                  </option>
                </select>
              </div>
            </div>
            <div v-if="taskOverview.nextTaskId > 0" class="col s6">
              <a :href="'?taskId=' + taskOverview.nextTaskId" class="btn btn-border fullWidth">Next Task <span class="ion-ios-arrow-thin-right"></span></a>
            </div>
          </div>
          <p></p>
            <span class="invalid_msg"> {{localTaskStatusUpdateMessage}}</span>
        </div>
      </div>
      <weather-segment v-if="recordingInformation" v-bind:date-string="recordingInformation.dateString" v-bind:location-id="recordingInformation.location.id" v-bind:site-latitude="recordingInformation.location.latitude" v-bind:site-longitude="recordingInformation.location.longitude" v-bind:show-date="false"></weather-segment>
    </div>
    <div class="container overflow tabbed">
      <ul class="tabs">
        <li class="tab left"><a :class="{active: showTab ==='main'}" @click="showTab='main'"><span class="ion-volume-medium"></span> Spectrograms</a></li>
        <li class="tab left" v-if="taskOverview.location && taskOverview.location.latitude"><a :class="{active: showTab === 'map'}" @click="showTab='map'"><span class="ion-map"></span> Map</a></li>
        <li class="tab left" v-if="taskOverview.taskId && taskOverview.isUserAdmin"><a :class="{active: showTab === 'audit'}" @click="clickedAuditTab()"><span class="ion-clipboard"></span> Audit</a></li>
        <li class="tab left" v-if="taskOverview.taskId && hasLocationVisitImages"><a :class="{active: showTab === 'photos' && hasLocationVisitImages}" @click="showTab = 'photos'"><span class="ion-ios-camera"></span>Location Photos</a></li>
      </ul>
      <div class="row">
        <div v-show="showTab === 'main'" id="spectrograms" class="col s12 panel boxed padded60">
          <div class="spectrogram-top row"><!--class="toggleWrap">-->
            <!-- Transcriber/Info panel buttons -->
            <span class="top-buttons-wrapper col m3">
              <span v-if="(taskOverview.isUserAdmin)" class="text-right text-toggle"> View all Recording Tasks <ToggleButton :value="!taskOverview.isUserTranscriber" color="#C94412" @change="toggleChange()"></ToggleButton></span>
            <!--  <span class="btn btn-border ion-edit userMod action" v-if="(taskOverview.isUserAdmin || isFullReadUser) && isAdminView" @click="isAdminView=false">As Transcriber</span>
              <span class="btn btn-border ion-ios-eye-outline userMod action" v-if="(taskOverview.isUserAdmin || isFullReadUser) && !isAdminView" @click="isAdminView=true">View As Admin</span> -->
              <span class="btn btn-noborder ion-eye-disabled text-right" v-if="showForm" @click="showForm=false">Hide Info Panel</span>
              <span v-if="!showForm" class="btn btn-noborder ion-eye text-right" @click="showForm=true">Show Info Panel</span>
            </span>
            <!-- Keyboard shortcuts -->
            <span class="mini-help-bar col s12 m9">
              <span class="currentStatus">Method: {{taskOverview.method && taskOverview.method.description}}</span>
              <v-popover id="hotkeys" placement='top' trigger='hover'>
              <span class="popover-target-button">Hotkeys</span>
              <template slot="popover">
              <div class="shortcuts">
                <span>Start/Stop (<span class="white-emphasis">Space</span>) </span>
                <span>| Skip Ahead (<span class="white-emphasis">M</span>) </span>
                <span>| Skip Backwards (<span class="white-emphasis">Z</span>) </span>
                <span>| Add Marker (<span class="white-emphasis">Shift</span>) </span>
                <span>| Previous Marker (<span class="white-emphasis arrow-key ion-arrow-left-b"></span>) </span>
                <span>| Next Marker (<span class="white-emphasis arrow-key ion-arrow-right-b"></span>) </span>
                <span>| First Marker (<span class="white-emphasis arrow-key ion-arrow-up-b"></span>) </span>
                <span>| Last Marker (<span class="white-emphasis arrow-key ion-arrow-down-b"></span>) </span>
                <span>| Hide/Show Boxes (<span class="white-emphasis">B</span>) </span>
                <span>| Hide/Show Text (<span class="white-emphasis">T</span>) </span>
                <span>| Hide/Show Left/Right Side (<span class="white-emphasis">L/R</span>)</span>
              </div> <!-- Hide Left (L) | Hide Right (R) -->
              </template>
              </v-popover>
              </span>
            <!-- <div class="col s10 m9 xl1"></div> -->
          </div>
          <div class="row" v-if="taskOverview.taskId != null && isAdminView != null && (taskOverview.isUserAdmin || taskOverview.isUserTranscriber || isFullReadUser)">
              <recording-play ref="recording" v-bind:task-update-message="taskUpdateMessage"
                v-bind:show-form="showForm" v-bind:task-overview="taskOverview" v-bind:options="options" v-bind:task="task" v-bind:is-admin-view="isAdminView">
              </recording-play>
          </div>
          <!-- -END SPECTROGRAM PANEL- -->
        </div>
        <div v-if="showTab === 'map'" id="mapsAndPhotos" class="col s12 panel boxed padded60">
          <div class="row">
            <div class="col s12 m12 l8">
              <point-map v-if="taskOverview && taskOverview.location.latitude && taskOverview.location.longitude" v-bind:latitude="parseFloat(taskOverview.location.latitude)" v-bind:longitude="parseFloat(taskOverview.location.longitude)" />
            </div>
            <div class="col s12 m12 l4">
              <div class="row gallery">
                <div v-for="(img, index) in taskOverview.photos" v-bind:key="'photo' + index" :src="img" @click="openZoomImage(img.url)" class="col s6 m4 l6 materialboxed">
                  <div class="thumbnail" :style="{'background-image': 'url(' + img.thumbNailURL + ')'}"></div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="showImage==true" class="modal modal-wrapper" ref="modalBox" @click="hideZoomImage">
            <div class="modal-container" @click="hideZoomImage">
            <!--div @click="showImage=false" class="iconButton"><span class="ion-close"></span> </div-->
              <img ref="zoomedImg" :src="largeImage">
            </div>
          </div>
          <!-- END MAP PANEL -->
        </div>
        <div v-if="showTab === 'audit'" id="auditHistory" class="col s12 panel boxed padded60">
          <div class="row">
            <div v-show="loading" style="text-align: center; margin-top:250px;">
              <pulse-loader :loading="true" color="#C94412" size="20px" :width="400" :height="400"></pulse-loader>
            </div>
            <div class="col s12 m12">
              <div v-if="auditsText != null">{{auditsText}}</div>
              <div class="audit" v-for="(line, index) in audits" v-bind:key="'audit' + index">
                <span class="audit-type">{{line.auditType}}</span>
                <span>{{line.audit}}</span>
              </div>
            </div>
          </div>
        </div>
      <!-- END AUDIT PANEL -->
        <div v-if="showTab === 'photos'" id="location-photos" class="col s12 panel boxed padded60">
          <div class="row">
            <div class="col s12 m12 l8">
              <location-photos v-if="$refs.recording.recording.location.id && taskOverview"
              v-bind:location-id="$refs.recording.recording.location.id" v-bind:project-id="taskOverview.projectId"/>
            </div>
          </div>
        </div>
        <!-- END LOCATION PHOTOS PANEL -->
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Vue from 'vue';
import RecordingPlayers from '@/components/ARU/RecordingPlayers';
import VueResource from 'vue-resource';
import {getParameterByName, attachAuthorizaitonHeader, API_URL} from '@/lib/common';
import { eventBus } from '@/lib/eventbus';
import SinglePointMap from '@/components/mapGL/SinglePointMap';
import { ToggleButton } from 'vue-js-toggle-button';
import VisitLocationPhotosVue from '../common/VisitLocationPhotos.vue';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue' // spinner for loading
import WeatherSegment from '@/components/common/WeatherSegment';
import { VPopover, VClosePopover } from 'v-tooltip';

Vue.use(VueResource);
Vue.component('ToggleButton', ToggleButton);
Vue.directive('close-popover', VClosePopover);
Vue.component('v-popover', VPopover);

export default {
  name: 'record-page',
  components: { 'recording-play': RecordingPlayers, 'weather-segment': WeatherSegment, 'point-map': SinglePointMap, 'ToggleButton': ToggleButton, 'location-photos': VisitLocationPhotosVue, 'pulse-loader': PulseLoader },
  created () { // get task information,
    attachAuthorizaitonHeader();
    const taskId = getParameterByName('taskId');
    if (!taskId) {
      this.error = 'Missing task information';
      return;
    }
    const that = this;
    eventBus.$on('toggle-form', function (showForm) {
      that.showForm = showForm;
    });
    eventBus.$on('update-task', function () {
      that.taskUpdateMessage = that.updateTask();
    });
    eventBus.$on('update-task-status', function () {
      that.taskUpdateMessage = that.updateTask();
    });
    eventBus.$on('update-task-status-display', function (displayStatusId) {
      that.updateTaskStatusDisplay(displayStatusId);
    });
    eventBus.$on('toggle-modal-form', function (name, show) {
      that.toggleDialog(name, show);
    });
    eventBus.$on('recording-ready', (recordingInfo) => {
      // info needed to load weather
      this.recordingInformation = recordingInfo;
    });

    const params = { params: { taskId: taskId } };
    this.$http.get(this.getTaskOverviewUrl, params).then(
      (response) => {
        // get body data
        if (response.data.hasOwnProperty.call('error')) {
          this.error = response.data.error;
        } else {
          this.taskOverview = response.data.taskOverview;
          this.task = response.data.task;
          this.taskOverview.taskId = this.task.id;
          this.orgStatusId = this.task.statusId;
          this.hasLocationVisitImages = response.data.taskOverview.hasLocationVisitImages;
          this.isAdminView = this.taskOverview.isUserAdmin && !this.taskOverview.isUserTranscriber;
          this.isFullReadUser = (!this.taskOverview.isUserTranscriber && !this.isAdminView);
        }
      }, (err) => {
      // error callback
        this.error = err;
      });

    this.$http.get(this.getTaskOptionUrl, params).then((response) => {
      this.options = response.data;
    }, (err) => {
    // error callback
      this.error = err;
    });
  },
  computed: {
    currentStatus () {
      for (let i = 0; this.options.taskStatus && i < this.options.taskStatus.length; i++) {
        if (this.options.taskStatus[i].id === this.orgStatusId) {
          return this.options.taskStatus[i].type;
        }
      }
      return 'Unknown';
    },
    markableTaskStatus () {
      if (this.options.taskStatus) {
        return this.options.taskStatus.filter(function (u) {
          return u.selectableByTranscriber;
        });
      }
      return null;
    },
    isStatusOptionVisible () {
    /*  if (this.options.taskStatus) {
        const currentStatus = this.options.taskStatus.find(status => status.id === this.task.statusId);
        if (currentStatus) {
          console.log(currentStatus);
          return currentStatus.updateableByTranscriber;
        }
      }
      return false; */
      if (this.options.taskStatus && (this.taskOverview.isUserAdmin || this.taskOverview.isUserTranscriber)) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    toggleDialog (dialogName, toShow) {
      if (toShow) {
        this.$modal.show(dialogName);
      } else {
        this.$modal.hide(dialogName);
      }
    },
    openZoomImage (img) {
      this.largeImage = img;
      this.showImage = true;
      const that = this;
      this.$nextTick(() => function (e) {
        that.$refs.modalBox.clientWidth = that.$refs.zoomedImg.clientWidth;
      });
    },
    hideZoomImage (img) {
      this.showImage = false;
    },
    markAsCompelete () {
      if (confirm('You are about to update project status. You will not be able to edit the task afterward, Please click OK to confirm')) {
        this.orgStatusId = this.newStatusId;
        this.updateTask(true);
      } else { // when cancel selection
        this.newStatusId = -1;
      }
    },
    updateTaskStatusDisplay (updatedStatusId) { // update status display after user inserted tags or markers
      if (updatedStatusId !== this.task.statusId) {
        this.task.statusId = updatedStatusId;
        this.orgStatusId = updatedStatusId;
        this.newStatusId = -1; // reset status id
      }
    },
    updateTaskStatus () { // just to distinguish the source of update and get error message back
      this.updateTask(true);
    },
    /* udpate task form, put here so, it can be called form parent component. */
    updateTask (statusOnly) {
      let dbStatusId = this.task.statusId;
      this.task.statusId = this.orgStatusId;
      let message = '';
      this.taskUpdateMessage = '';
      this.localTaskStatusUpdateMessage = '';
      this.$http.put(this.updateTaskUrl, this.task).then(function (response) {
        if (response.data.hasOwnProperty.call('error')) {
          this.task.statusId = dbStatusId;
          this.orgStatusId = dbStatusId;
          if (response.data.error.indexOf('MARKERS EXIST') !== -1) {
            alert(this.markExistMsg);
            return;
          }
          this.newStatusId = -1; // reset status id
          message = 'Update failed: ' + response.data.error;
        } else {
          this.task = response.body;
          message = 'Task Info successfully updated!';
        }
        if (statusOnly) {
          this.localTaskStatusUpdateMessage = message;
        } else {
          this.taskUpdateMessage = message;
        }
      });
    },
    clickedAuditTab () {
      this.showTab = 'audit';
      this.loading = true;
      this.auditsText = null;
      const params = { params: { taskId: this.task.id } };
      if (this.taskOverview.isUserAdmin) {
        // audit history for admins only
        this.$http.get(this.getTaskAuditHistory, params).then((response) => {
          if (response.body.hasOwnProperty.call('error')) {
            this.auditsText = 'Error getting audit information. ' + response.body.error;
          } else {
            this.audits = response.data.map(x => {
              var splitAudit = {auditType: x.substring(0, x.indexOf(' ')), audit: x.substring(x.indexOf(' ') + 1)};
              return splitAudit;
            });
            this.loading = false;
            if (this.audits.length === 0) {
              this.auditsText = 'No deleted tags found for audit.';
            }
          }
        }, (err) => {
          // error callback
          this.error = err;
        });
      }
    },
    toggleChange () {
      this.isAdminView = !this.isAdminView;
      document.activeElement.blur();
    }
  },
  data () {
    return {
      getTaskOverviewUrl: API_URL + 'get-task-overview?',
      getTaskOptionUrl: API_URL + 'task-options',
      updateTaskUrl: API_URL + 'update-task',
      getTaskAuditHistory: API_URL + 'get-task-audit-history',
      markExistMsg: 'You still have yellow markers on your spectrogram. Please ensure you have drawn boxes corresponding to these markers and then click the marker to remove it from the spectrogram. You cannot change the status of this task to complete until all markers are removed.',
      auditsText: null,
      showForm: false,
      showTab: 'main',
      taskOverview: {},
      orgStatusId: null,
      newStatusId: -1, // for transcriber purpose
      statusOption: {},
      options: [],
      audits: [],
      loading: false,
      task: {},
      error: null,
      isAdminView: null,
      isFullReadUser: null,
      hasLocationVisitImages: null,
      taskUpdateMessage: '',
      localTaskStatusUpdateMessage: '',
      largeImage: '',
      showImage: false,
      recordingInformation: null
    }
  }
}
</script>
<style lang='scss'>
.toggleWrap #toggleInfo .ion-eye-disabled {
    display: block;
}
.currentStatus{
  color: #1369c5;
  font-weight: 800;
}
.userMod {
  color:#c94412;
}
/*
.spectrogram-top{
  display:flex;
  flex-direction: row;
  justify-content: space-between;
}*/

/*
.padding-right {
  padding-right: 30px;
  float:right;
}
.padding-right .action {
  cursor:pointer;
}*/
.row .col .thumbnail {
  min-height: 200px;
  background-position: cover;
  background-size: 100%;
  background-repeat: no-repeat;
}
#mapsAndPhotos .iconButton {
  float: right;
  width: 50px;
}

#mapsAndPhotos .modal-wrapper {
  display: flex;
  align-items:center;
  justify-content:center;
  height:100%;
  z-index: 1003;
  top: 10%;
}

#mapsAndPhotos .modal-container{
    display:inline-block;
    width:auto;
}

.audit{
  margin-bottom: 10px;
}

  .audit-type{
    font-weight: 800;
  }

@media only screen and (max-width: 992px) {
  .row.gallery {
    margin-top:30px;
  }
  .row .col .thumbnail {
    min-height: 150px;
  }
}

.tabbed .tab {
  cursor: pointer;
}
.jwplayer {
  display:none;
}
.NoiseLevel span {
  color: #1369c5;
  font-weight: 800;
}

.btn.btn-noborder {
  background-color: transparent;
  color: #646464;
  border: 0px;
  margin: 0
}

.mini-help-bar{
    text-transform: uppercase;
    letter-spacing: 2px;
    font-weight: 300;
    font-size: 0.8rem;
    color: #9E9E9E;
}

.red-link{
    display: inline;
    color: #C94412;
    padding-right: 12px;
    cursor: pointer;
}

p .red-link{
  font-weight:normal;
  padding-left:5px;
}

.white-emphasis{
  color: #FFFFFF;
  font-weight:800;
}

.top-buttons-wrapper{
  float:right !important;
  display: flex;
  flex-direction: column;
}

.shortcuts > span{
  white-space: nowrap;
}

.text-right{
    text-align: right;
}

.text-toggle{
  font-size:14px;
  color: #646464;
  font-weight: 600;
}

.no-statusOption{
  margin-top: 3em;
}

.recording-status-wrapper{
  margin-block-start: 1em;
  margin-block-end: 1em;
}

.no-float{
  float: none !important;
}

.tooltip {
  // ...

  &.popover {
    $color: #C94412;

    .popover-inner {
      background: $color;
      color: white;
      padding: 10px;
      border-radius: 2px;
      box-shadow: 0 5px 30px rgba(black, .1);
    }

    .wrapper{
      padding-top: 0px;
    //  transform-origin: top left;
    //  width: 825px;
    }

    .popover-arrow {
      border-color: $color;
    }

    .popover-menu-item{
      width: 100%;
      display: block;
      background-color: transparent !important;
      border:none;
    }
  }
}

.popover.tooltip[aria-hidden='false']{
  max-width: 70% !important;
}

@media only screen and (max-width: 1150px) {
.popover.tooltip[aria-hidden='false']{
  max-width: 80% !important;
  }
}

@media only screen and (max-width: 1000px) {
.popover.tooltip[aria-hidden='false']{
  max-width: 100% !important;
  }
}

.tooltip-arrow {
  z-index: 1;
}

.popover-target-button{
  color: #C94412 !important;
  text-decoration: underline;
  cursor: default;
}

#hotkeys{
  display: inline !important;
}
</style>
